// extracted by mini-css-extract-plugin
export var contrastLow = "_38-1";
export var externalLink = "_38-2";
export var externalLinkIcon = "_38-3";
export var link = "_38-0";
export var linkLabel = "_38-4";